module.exports = __webpack_public_path__ + "static/media/bus.45da9f72.svg";